<mat-form-field [ngClass]="{ 'tw-pb-0': removeBottomPadding }">
  <mat-label>
    {{ label }}
  </mat-label>
  <input
    matInput
    [formControl]="dateTimeRangeControl"
    [owlDateTime]="datetimePicker"
    [owlDateTimeTrigger]="datetimePicker"
    [selectMode]="'range'"
    [readonly]="true"
  />

  <ng-container *ngIf="prefix" matPrefix>
    <ng-container *ngTemplateOutlet="prefix"></ng-container>
  </ng-container>

  <ng-container matSuffix>
    <ng-container *ngIf="!suffix; else suffix">
      <ui-svg-icon
        [name]="iconNames.CalendarClock"
        class="tw-cursor-pointer"
        (click)="datetimePicker.open()"
      ></ui-svg-icon>
    </ng-container>
  </ng-container>

  <owl-date-time #datetimePicker [pickerType]="pickerType"></owl-date-time>
</mat-form-field>
